module.exports = __webpack_public_path__ + "img/张宏宇.021e38df.png";